// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2019":"d6209356c5b5d1c3","2091":"9cd0dfaef403e3d0","2740":"dd6a017710e25373","2957":"24e19fdefb010431"}[chunkId] + ".css";
};